export const reasonOptions = [
    // ordered alphabetically
    // values for these options are the same as the label
    // if they differ it is to maintain mapping from the legacy system
    {
        value: 'Unknown',
        label: 'WEB ONLY - No reason provided',
    },
    {
        // casing on the value is different to match previous data
        value: 'support',
        label: 'Customer service issue',
    },
    {
        value: 'Insufficient Capacity',
        label: 'LawnStarter - Insufficient Capacity',
    },
    {
        value: 'LawnStarter - Customer fraud',
        label: 'LawnStarter - Customer fraud',
    },
    {
        value: 'moving',
        label: 'Moving',
    },
    {
        value: 'charges',
        label: 'Payment issue',
    },
    {
        value: 'pricing',
        label: 'Pricing Issue',
    },
    {
        value: 'quality',
        label: 'Quality Issue',
    },
    {
        value: 'scheduling',
        label: 'Scheduling Issue',
    },
    {
        value: 'temporary',
        label: 'Temporary cancellation',
    },
];

export const mowAsSoonAsPossibleOptions = [
    {
        value: true,
        label: 'Yes',
    },
    {
        value: false,
        label: 'No',
    },
];

export const confirmationOptions = [
    {
        label: 'I have confirmed with the customer that they want to cancel this service',
        value: false,
    },
];
